var Main = (function() {
    $(function(){
        Main.init();
    })
    return{
        init: function(){
            var _self = this;
            _self.breadcrumbs();
            _self.header();
            _self.headerMobile();
            _self.mainSlider();
            _self.actionSlider();
            _self.accordion();
            _self.magnificGallery();
            _self.slickGallery();
            _self.selectStyle();
            _self.upButton();
        },
        breadcrumbs: function () {
            $(".js-lastcrumb").click(function(e) {
                e.stopPropagation();
                e.preventDefault();
            })
        },
        header: function () {
            if($('.js_header_main__submenu_li.js_active').length == 0) {
                   $('.js_header_main__submenu_li').first().addClass('js_active');
               }
             $(".js_header_main__submenu_li").hover(function(){
                 $('.js_header_main__submenu_li').removeClass('js_active');
                 $(this).addClass('js_active');
             });
        },
        headerMobile: function () {
            $(document).on('click', '.js_header_btn', function() {
                if(!$(this).hasClass('js_active')) {
                    $(this).addClass('js_active');
                    $('.js_header_main').addClass('js_active');
                    $('.js_header_main_menu').addClass('js_active');
                    $('body').addClass('overflow');
                } else {
                    $(this).removeClass('js_active');
                    $('.js_header_main').removeClass('js_active');
                    $('.js_header_main_menu').removeClass('js_active');
                    $('body').removeClass('overflow');
                }
            });
            $(document).on('click', '.js_btn_mobile_submenu', function() {
                if($(window).width() < 1200) {
                    $(this).toggleClass("js_active");
                    $('.js_mobile_submenu').toggleClass('js_active');
                }
            });
        },
        mainSlider: function () {
            var timeout = $('.js_main_slider').attr('data-timeout');
              $('.js_main_slider').slick({
                autoplay: timeout != 0 ? true : false,
                autoplaySpeed: timeout != 0 ? timeout * 1000 : '',
                arrows:false,
                dots:true,
                infinite: true,
                draggable: true,
                swipe: true,
                lazyLoad: 'ondemand',
                responsive:[
                        {
                            breakpoint : 901,
                            settings: {
                               adaptiveHeight: true,
                            }
                        },
                     ]
             });
        },
        actionSlider: function () {
                $('.js_actions_slider').slick({
                  dots: false,
                  arrows: false,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true,
                  draggable: true,
                  swipe: true,
                  lazyLoad: 'ondemand',
                  responsive:[
                          {
                              breakpoint : 901,
                              settings: {
                                 dots: true,
                                 slidesToShow: 1,
                                 adaptiveHeight: true,
                              }
                          },
                       ]
              });
        },
        accordion: function () {
            var btnsAccords = document.querySelectorAll('.js_accord_btn');
            if (btnsAccords) {
                for (var i = 0; i< btnsAccords.length; i++) {
                    btnsAccords[i].addEventListener('click', funcAccordion);
                }
            };
            function funcAccordion () {
                 var parentAccord = this.closest('.js_accord_btns');
                 var dataBtn = this.getAttribute('data-accordion');
                 if(!this.classList.contains('js_active_accord')) {
                     var btnAccord = parentAccord.querySelectorAll('.js_accord_btn');
                     for (var i = 0; i < btnAccord.length; i++) {
                        btnAccord[i].classList.remove('js_active_accord');
                     }
                     this.classList.add('js_active_accord');
                     var accordBody = parentAccord.querySelectorAll('.js_accord_block');
                     for (var i = 0; i < accordBody.length; i ++) {
                         var dataBlock = accordBody[i].getAttribute('data-accordBlock');
                         accordBody[i].classList.remove('js_active_accord');
                         if (dataBtn == dataBlock) {
                             accordBody[i].classList.add('js_active_accord');
                         }
                     }
                 } else {
                     this.classList.remove('js_active_accord');
                     parentAccord.querySelector(`.js_accord_block[data-accordBlock=${dataBtn}]`).classList.remove('js_active_accord');
                 }
             }
        },
        magnificGallery: function () {
            $('.magnific').magnificPopup({
               type: 'image',
               fixedContentPos: true,
               gallery: {
                   enabled: true,
                   navigateByImgClick: true,
                   preload: [0,1],
               },
             });
        },
        slickGallery: function () {
            $('.gallery_block_slick').slick({
                slidesToShow: 4,
                slidesToScroll: 4,
                autoplay: false,
                autoplaySpeed: 2000,
                dots: false,
                infinite:true,
                speed: 1000,
                arrows: true,
                draggable: true,
                lazyLoad: 'ondemand',
                prevArrow: '<div class="slick-arrow_prev slider-controls slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.2 477.2"><path d="M145.2 238.6l215.5-215.5c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-225.1 225.1c-5.3 5.3-5.3 13.8 0 19.1l225.1 225c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1L145.2 238.6z"/></svg></div>',
                nextArrow: '<div class="slick-arrow_next slider-controls slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"><path d="m40.4 121.3c-0.8 0.8-1.8 1.2-2.9 1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8 0l53.9 53.9c1.6 1.6 1.6 4.2 0 5.8l-53.9 53.9z"/></svg></div>',
                responsive: [
                     {
                       breakpoint: 769,
                       settings: {
                         slidesToShow: 3,
                         slidesToScroll: 3,

                       }
                   },
                   {
                     breakpoint: 481,
                     settings: {
                       slidesToShow: 2,
                       slidesToScroll: 2,

                     }
                 }
                ]
            });
        },
        selectStyle: function () {
            function select () {
                $('.js_select').selectric({
                    disableOnMobile: false,
                    nativeOnMobile: false
                });
            }
            select();
        },
        upButton: function () {
            $("#up_button").on("click", function(e) {
                  $('html, body').animate({
                      scrollTop: 0
                  }, 500)
            });
        },
    }
})(jQuery);

window.onscroll = function(){
    if ($(this).scrollTop() > 350){
        $('#up_button').addClass('js_visible');
    }
    else{
        $('#up_button').removeClass('js_visible');
    }
};
window.onload = function () {
    if ($(this).scrollTop() > 350){
        $('#up_button').addClass('js_visible');
    }
    else{
        $('#up_button').removeClass('js_visible');
    }
};

$(window).on('resize', function () {
    if($(window).width() >=1200) {
        headerMobileOpenClose ();
    }  
});

function headerMobileOpenClose () {
    $('.js_header_btn').removeClass('js_active');
    $('.js_header_main').removeClass('js_active');
    $('.js_header_main_menu').removeClass('js_active');
    $('body').removeClass('overflow');
    $('.js_btn_mobile_submenu').removeClass("js_active");
    $('.js_mobile_submenu').removeClass("js_active");
}
